import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const Instruments = ({ listInstruments, listInstrumentsTable }) => {
    return (
        <div className="pochtabank-instruments">
            <FullWrapper className="pochtabank-instrumentsCase">
                <div className="pochtabank-instrumentsTitle">
                    Итоговый набор ключевых инструментов front&#8209;end&nbsp;части&nbsp;проекта
                </div>

                <div className="pochtabank-instrumentsInner">
                    <div className="pochtabank-instrumentsLeft">
                        <div className="pochtabank-instrumentsTable">
                            {listInstrumentsTable.map((item, index) => (
                                <div className="pochtabank-instrumentsRow" key={index}>
                                    <div
                                        className="pochtabank-instrumentsType"
                                        dangerouslySetInnerHTML={{ __html: item.type }}
                                    />
                                    <div
                                        className="pochtabank-instrumentsInstrument"
                                        dangerouslySetInnerHTML={{ __html: item.instrument }}
                                    />
                                    <div
                                        className="pochtabank-instrumentsComment"
                                        dangerouslySetInnerHTML={{ __html: item.comment }}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="pochtabank-instrumentsRight">
                        <div className="pochtabank-instrumentsRightText">
                            Итоговый набор инструментов
                        </div>
                        <div className="pochtabank-instrumentsRightItems">
                            {listInstruments.map((item, index) => (
                                <div className="pochtabank-instrumentsRightItem" key={index}>
                                    <img
                                        src={item.icon}
                                        alt="icon"
                                        className="pochtabank-instrumentsRightIcon"
                                    />
                                    <div className="pochtabank-instrumentsRightName">
                                        {item.text}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Instruments;
